var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradeActive = function SvgGradeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "grade-active_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#grade-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "M11.092 3.461a1 1 0 0 1 1.816 0l2.369 5.12 5.592.681a1 1 0 0 1 .561 1.724l-4.128 3.852 1.083 5.546a1 1 0 0 1-1.469 1.065L12 18.704l-4.916 2.745a1 1 0 0 1-1.47-1.065l1.084-5.546-4.128-3.852a1 1 0 0 1 .561-1.724l5.592-.68 2.37-5.12Z"
  }))));
};
export default SvgGradeActive;